/* eslint-disable */

import request from '@/utils/request'

export function getListArAccount(query) {
  return request({
    url: '/config-service/v1/debit-account/list',
    method: 'get',
    params: query
  })
}

export function getArAccountById(id) {
  return request({
    url: `/config-service/v1/debit-account/${id}`,
    method: 'get'
  })
}

export function addArAccountApi(query) {
  return request({
    url: '/config-service/v1/debit-account/insert',
    method: 'post',
    data: query
  })
}

export function updateArAccountApi(data) {
  return request({
    url: `/config-service/v1/debit-account/update/${data.id}`,
    method: 'put',
    data: data
  })
}

export function deleteArAccount(query) {
  return request({
    url: '/config-service/v1/debit-account/delete-ids',
    method: 'delete',
    data: query
  })
}

export function getListInvoiceByArAccount(params) {
  return request({
    url: '/cashier-service/v1/debt-invoice/invoices',
    methods: 'get',
    params: params
  })
}

export function downloadArAccountList(query) {
  return request({
    url: '/config-service/v1/debit-account/to-excel',
    method: 'get',
    params: query,
    responseType: 'arraybuffer'
  })
}

export function getRoomTransactionBooking(params) {
  return request({
    url: '/cashier-service/v1/debt-invoice/booking',
    method: 'get',
    params: params
  })
}

export function addNewInvoice(query) {
  return request({
    url: '/cashier-service/v1/room-transaction/invoice',
    method: 'post',
    data: query
  })
}

export function getPaymentRowsApi(params) {
  return request({
    url: '/cashier-service/v1/debt-invoice/payments',
    method: 'get',
    params: params
  })
}

export function getInvoiceByPaymentApi(params) {
  return request({
    url: '/cashier-service/v1/debt-invoice/invoices',
    method: 'get',
    params: params
  })
}

export function applyDebtInvoiceApi(params, data) {
  return request({
    url: '/cashier-service/v1/debt-invoice/apply',
    method: 'post',
    params: params,
    data: data
  })
}

export function unApplyDebtInvoiceApi(id) {
  return request({
    url: `/cashier-service/v1/debt-invoice/cancel-apply/${id}`,
    method: 'post'
  })
}

export function addNewDebtPaymentApi(data) {
  return request({
    url: '/cashier-service/v1/debt-invoice/payment',
    method: 'post',
    data: data
  })
}

export function deleteDebtInvoicePaymentApi(id) {
  return request({
    url: `/cashier-service/v1/debt-invoice/payment/${id}`,
    method: 'delete'
  })
}
